<template>
	<div :class="$style.ebay">
		<BaseTooltip v-if="notification.date" position="right" :content="date">
			<TimeAgo
				:class="[$style['color'], $style['color--grey']]"
				:timestamp="timestamp"
			/>
		</BaseTooltip>
		<i18n
			path="notifications.types.ebay-invalid-token.message"
			tag="p"
			:class="$style['ebay__message']"
			class="notification__title"
		>
			<strong>{{ notification.tokenUsername }}</strong>
		</i18n>
		<p :class="$style['ebay__notice']">
			{{ $t("notifications.types.ebay-invalid-token.notice") }}
		</p>
		<button :class="$style['ebay__button']" @click="createAndGoToSingIn">
			{{ $t("notifications.types.ebay-invalid-token.cta") }}
			<FontAwesomeIcon
				:icon="icons.faLongArrowRight"
				:class="$style['ebay__button-icon']"
			/>
		</button>
	</div>
</template>

<script>
import gql from 'graphql-tag'
import { faLongArrowRight } from '@fortawesome/pro-light-svg-icons'
import moment from '@/packages/moment'
import TimeAgo from '@/components/Essentials/TimeAgo'
export default {
	name: 'EbayTokenInvalidNotification',
	components: {
		TimeAgo
	},
	props: {
		notification: {
			type: Object,
			required: true
		}
	},
	data () {
		return {
			icons: {
				faLongArrowRight
			}
		}
	},
	computed: {
		date () {
			if (this.notification.date) {

				return moment(this.notification.date).format('LLLL')
			}
			return null
		},
		timestamp () {
			if (this.notification.date) {

				return new Date(this.notification.date).getTime()
			}
			return null
		}
	},
	methods: {
		async createAndGoToSingIn () {
			const { data } = await this.$apollo.mutate({
				mutation: gql`
					mutation GetEbaySigninUrl ($payload: GetEbaySigninUrlInput!){
						getEbaySigninUrl (payload: $payload) {
							url
						}
					}
				`,
				variables: {
					payload: {
						departmentId: this.$auth().selectedDepartmentId
					}
				}
			})
			window.open(data.getEbaySigninUrl.url)
		}
	}
}
</script>
<style lang="scss" module>
.color {
    font-size: 12px;

    &--grey {
        color: getColor(sub-text);
    }
}

.ebay {
    font-size: 16px;

    &__message {
        margin: 0;
        margin-bottom: calc($gutter / 2);
        margin-top: calc($gutter / 2);
    }

    &__notice {
        margin: 0;
        margin-bottom: calc($gutter / 2);
        font-size: 14px;
        color: getColor(sub-text);
    }

    &__button {
        display: flex;
        align-items: center;
        appearance: none;
        border: 0;
        padding: 0;
        font-size: 16px;
        border-radius: 6px;
        color: getColor(primary);
        background-color: transparent;
        transition: all 0.15s ease;

        &:active,
        &:focus {
            outline: 0;
        }

        &:hover {
            cursor: pointer;
            color: getColor(primary-hover);
            background-color: getColor(hover-overlay);
        }
    }

    &__button-icon {
        margin-left: calc($gutter / 2);
        font-size: 16px;
    }
}
</style>
